import React from 'react';

import { ISVGPersonalProps } from 'types/svg';

export const checkboxUnchecked: ISVGPersonalProps = {
  viewBox: '0 0 15 15',
  content: (
    <>
      <defs>
        <filter id="Rectangle_62">
          <feOffset />
          <feGaussianBlur stdDeviation="0.5" result="blur" />
          <feFlood floodOpacity="0.161" result="color" />
          <feComposite operator="out" in="SourceGraphic" in2="blur" />
          <feComposite operator="in" in="color" />
          <feComposite operator="in" in2="SourceGraphic" />
        </filter>
      </defs>
      <g data-type="innerShadowGroup">
        <rect id="Rectangle_62-2" data-name="Rectangle 62" width="15" height="15" rx="3" fill="#fff" />
        <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#Rectangle_62)">
          <rect id="Rectangle_62-3" data-name="Rectangle 62" width="15" height="15" rx="3" fill="#fff" />
        </g>
        <g id="Rectangle_62-4" data-name="Rectangle 62" fill="none" stroke="#f2f2f2" strokeWidth="1">
          <rect width="15" height="15" rx="3" stroke="none" />
          <rect x="0.5" y="0.5" width="14" height="14" rx="2.5" fill="none" />
        </g>
      </g>
    </>
  ),
};
